module.exports = "/_next/static/chromiums/apple-touch-startup-1242x2208-image-ab25c2e3dc7887dad5675419d33226c3.png";